import { Button, Input, Switch } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import React, { useMemo } from "react";
import { UTILS } from "utils";
import { useTranslation } from "react-i18next";
import { CONSTANTS as C } from "config";
// import s from "./branding.module.css";
import ColorPicker from "components/ColorPicker";
import AppSwitch from "components/ui/AppSwitch"
import AppColorPicker from "components/ui/AppColorPicker";
import AppInput from "components/ui/AppInput"
import { validateVideoFile } from "utils/Validator";
import { getBase64 } from "utils/Utils";
import AppImageVideoUpload from "components/ui/AppImageVideoUpload";
import BusinessInfo from "../create/BusinessInfo";

const UploadMessage = ({text= "Drag and drop cover image or", hideBrowseText =false})=>{
  const { t } = useTranslation()
  return (
    <div
    className="flex justify-center items-center flex-col"
    style={{ height: 220 }}
  >
    <svg
      viewBox="0 0 20 20"
      xmlns="https://www.w3.org/2000/svg"
      fill="#d0dbe3"
      className="w-10 h-10 inline-block"
    >
      <path
        fillRule="evenodd"
        clip-rule="evenodd"
        d="M4.288 0A2.8 2.8 0 001.74 1.641L.236 4.95A2.741 2.741 0 00.5 7.677c.328.459.74.82 1.198 1.077V18.2A1.8 1.8 0 003.5 20h13a1.8 1.8 0 001.8-1.8V8.756c.46-.258.873-.62 1.201-1.08.57-.796.67-1.836.265-2.727l-1.503-3.308A2.8 2.8 0 0015.712 0H4.29zM16.7 9.224a3.694 3.694 0 01-2.634-.887l-.531-.455c-.161.14-.354.294-.575.448-.693.486-1.729 1.02-2.958 1.02-1.23 0-2.266-.534-2.96-1.02a7.14 7.14 0 01-.574-.448l-.53.455a3.694 3.694 0 01-2.638.887V18.2c0 .11.09.2.2.2H7V15a3 3 0 116 0v3.4h3.5a.2.2 0 00.2-.2V9.224zM3.196 2.304A1.2 1.2 0 014.288 1.6h11.425a1.2 1.2 0 011.092.703l1.504 3.308c.168.371.126.804-.11 1.136a2.112 2.112 0 01-3.093.375l-1.692-1.45-.52.606-.007.008-.038.042a5.553 5.553 0 01-.807.692c-.557.39-1.271.73-2.041.73s-1.485-.34-2.042-.73a5.544 5.544 0 01-.845-.734l-.008-.009-.519-.605-1.692 1.45a2.112 2.112 0 01-3.092-.375 1.141 1.141 0 01-.11-1.136l1.503-3.308zM11.4 18.4V15a1.4 1.4 0 10-2.8 0v3.4h2.8z"
      ></path>
    </svg>
    <div className="text-gray-500">
      {t(text)} {!hideBrowseText && <> <br />
      <span className="text-blue-400">{t("browse")}</span>{" "}
      {t("to upload")}
      </>}
    </div>
  </div>
  )
}

const BrandingPlatformCustomizeAndWidget = ({
  setSettings,
  settings,
  orderNowPopupConfig,
  setOrderNowPopupConfig,
  handleChange,
  onPreview,
  uploadButton,
  beforeUpload,
}) => {
  const { t } = useTranslation();

  const handleValues = (key, val) => {
    setSettings((prev) => ({
      ...prev,
      [key]: val,
    }));
  };
  const handleConfig = (key, val) => {
    setOrderNowPopupConfig((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleVideoChange = async ({file}) => {
    const isValidVideo = validateVideoFile(file)
    if(isValidVideo){
      handleValues("video",file)
      handleValues("showBannerVideo",'true')
      const bas64 = await getBase64(file)
      if(bas64)
        handleValues("brandVideoHomeBG",bas64)
    }
  }

  return (
    <div>
      <div className="w-full">
      <BusinessInfo
        defaultOpen={true}
        businessName={settings?.browserTabTitle || ""}
        domainName={settings?.temporaryDomainName || ""}
        domainNamePlaceholder={settings?.temporaryDomainName || ""}
        onBusinessNameChange={(value) => handleValues("browserTabTitle", value)}
        onDomainNameChange={(value) => handleValues("temporaryDomainName", value)}
      />
        <label className=" text-gray-600 block text-14px font-bold">
          {t("Cover image")}
        </label>
        <h3 className="text-gray-500">
          {t(
            "2 MB is the maximum size allowed. In order to get the best results, keep the width (620 px) and height (350 px). Only JPEGs and PNGs are allowed."
          )}
        </h3>
        <AppImageVideoUpload
          label=""
          height="auto"
          maxSizeMB={2}
          accept="image/*"
          value={settings?.brandImageHomeBG}
          onChange={(info) => handleChange(info, "brandImageHomeBG")}
          action={C.BASE_URL + "user/uploadFile"}
          headers={{
            Authorization: `Bearer ${UTILS.getCurrentUser().token}`,
          }}
          name="image"
          cropAspect={620 / 350}
          cropRotate
          beforeUpload={beforeUpload}
          onPreview={onPreview}
          showGuidelines={false}
        />
      </div>
      {/* <div className="">
        <label className="mt-10 text-gray-600 block text-14px font-bold">
          {t("Cover video")}
        </label>
        <h3 className="text-gray-500">
          {t(
            "Maximum file size allowed is 5 MB. Supported video formats i.e. MP4, WebM, OGG, AVI, MOV, WMV, FLV, and MKV"
          )}
        </h3>
        <Dragger
          style={{ height: 350 }}
          className="w-full max-w-lg lg:m-w-full border  border-dashed rounded"
          name="video"
          accept="video/*"
          showUploadList={false}
          onChange={handleVideoChange}
          beforeUpload={() => false}
        >
          {settings?.brandVideoHomeBG && settings?.showBannerVideo === "true" ? (
            <div
              className="flex justify-center items-center flex-col relative"
              style={{ height: 220 }}
            >
              <div className="absolute top-0 left-0 w-full h-full">
                <video
                  src={settings?.brandVideoHomeBG}
                  muted
                  autoPlay
                  loop
                  className="w-full h-full object-cover"
                  style={{
                    // zIndex: 0,
                    background: "transparent",
                    filter: "blur(10px)",
                  }}
                ></video>
              </div>
              <div
                className="absolute top-0 left-0 w-full h-full"
                style={{
                  zIndex: 1,
                }}
              >
                <video
                  autoPlay
                  muted
                  loop
                  className="w-full h-full"
                  src={
                    settings?.brandVideoHomeBGBase64 ??
                    settings?.brandVideoHomeBG
                  }
                />
              </div>
            </div>
          ) : (
            <UploadMessage
              text={
                settings?.brandVideoHomeBG && settings?.showBannerVideo !== "true"
                  ? "Preview Hide"
                  : "Drag and drop cover video or"
              }
              hideBrowseText={
                settings?.brandVideoHomeBG && settings?.showBannerVideo !== "true"
              }
            />
          )}
        </Dragger>
      </div> */}
      {/* <div className="flex gap-6  mt-6 items-center">
        <div className="flex gap-2 items-center">
          <label className="text-gray-600 font-bold text-14px">
            {t("Show Cover Video")}
          </label>
          <Switch
            style={
              settings?.showBannerVideo === "true"
                ? { backgroundColor: "#01d392" }
                : {}
            }
            checked={settings?.showBannerVideo === "true" ?? false}
            disabled={!settings?.brandVideoHomeBG}
            onChange={(e) => handleValues("showBannerVideo", e?.toString())}
          />
        </div>
        <Button
          type="primary"
          danger
          icon={<DeleteOutlined />}
          disabled={!settings?.brandVideoHomeBG}
          onClick={() => {
            handleValues("brandVideoHomeBG", "");
            handleValues("brandVideoHomeBGBase64", null);
            handleValues("showBannerVideo", "false");
            handleValues("mediaToDelete", [
              ...(settings?.mediaToDelete ?? []),
              settings?.brandVideoHomeBG,
            ]);
          }}
        >
          {t("Delete Cover Video")}
        </Button>
      </div> */}
      <div className="flex items-center gap-2 mt-6">
        {/* <label className="text-gray-600 block text-14px font-bold">
          {t("Enable Store Cards View")}
        </label> */}
        <AppSwitch
          label={t("Enable Store Cards View")}
          labelLeft={true}
          checked={settings?.enableStoreListingView === "true" ?? false}
          onChange={(e) => handleValues("enableStoreListingView", e?.toString())}
        />
      </div>
      <div className="flex flex-col 490x:flex-row">
        <div className="pb-2 me-0 md:me-1 w-full md:w-1/2">
          <AppColorPicker label={t("Text color")} value={settings?.textColor} pkey="textColor" onChange={handleValues}/>
          
          {/* <label className="mt-10 text-gray-600 block text-14px font-bold">
            {t("Text color")}
          </label>
          <div className="border flex p-1">
            <div className="px-2 flex items-center">
              <ColorPicker
                onChange={handleValues}
                colorValue={settings?.textColor}
                pkey="textColor"
              />
            </div>
            <div className=" flex items-center" dir="ltr">
              {settings?.textColor}
            </div>
          </div> */}
        </div>
        <div className="pb-2 me-0 md:me-1 w-full md:w-1/2">
          <AppColorPicker label={t("Base color")} value={settings?.color} pkey="color" onChange={handleValues}/>
          {/* <label className="mt-2 490x:mt-10 text-gray-600 block text-14px font-bold">
            {t("Base color")}
          </label>
          <div className="border flex p-1">
            <div className="px-2 flex items-center">
              <ColorPicker
                onChange={handleValues}
                colorValue={settings?.color}
                pkey="color"
              />
            </div>
            <div className=" flex items-center" dir="ltr">
              {settings?.color}
            </div>
          </div> */}
        </div>
      </div>
      <div className="py-4 w-full">
        <AppInput 
          label={t("Tag line")}
          placeholder={t("Enter Tagline")} 
          value={settings?.taglineEN}
          maxLength={65} 
          
          onInput={(event) => {
            const inputValue = event.target.value;
            if (inputValue.length <= 65) {
              handleValues("taglineEN", inputValue);
            } else {
              handleValues("taglineEN", inputValue.substring(0, 65));
            }
          }}/>
          </div>
        {/* <div className="flex justify-between">
          <label className="text-gray-600 font-bold text-14px">
            {t("Tag line")}
          </label>
          <label className="text-14px text-gray-400">
            {t("Max 65 Charaters Allowed")}
          </label>
        </div>
        <Input
          maxLength={65}
          compact
          placeholder={t("Enter Tagline")}
          value={settings?.taglineEN}
          className="py-2 rounded"
          onChange={(event) => {
            const inputValue = event.target.value;
            if (inputValue.length <= 65) {
              handleValues("taglineEN", inputValue);
            } else {
              handleValues("taglineEN", inputValue.substring(0, 65));
            }
          }}
        />
      </div> */}

      <div className="py-2 w-full md:w-1/2">
        <label className=" text-gray-600 block text-14px font-bold">
          {t("Brand logo")}
        </label>
        <h3 className="text-gray-500">
          {t(
            "2 MB is the maximum size allowed. In order to get the best results, keep the width (160 px) and height (160 px). Only JPEGs and PNGs are allowed."
          )}
        </h3>
        <AppImageVideoUpload
          label=""
          height="auto"
          maxSizeMB={2}
          accept="image/*"
          value={settings?.brandLogoFirst}
          onChange={(info) => handleChange(info, "brandLogoFirst")}
          name="image"
          cropAspect={1}
          cropRotate
          beforeUpload={beforeUpload}
          onPreview={onPreview}
          showGuidelines={false}
        />
      </div>

      <div className="py-2 w-full md:w-1/2">
        <label className=" text-gray-600 block text-14px font-bold">
          {t("Favicon")}
        </label>
        <h3 className="text-gray-500">
          {t(
            "2 MB is the maximum size allowed. In order to get the best results, keep the width (16 px) and height (16 px). Only JPEGs and PNGs are allowed."
          )}
        </h3>
        <AppImageVideoUpload
          label=""
          height="auto"
          maxSizeMB={2}
          accept="image/*"
          value={settings?.brandFavicon}
          onChange={(info) => handleChange(info, "brandFavicon")}
          name="image"
          cropAspect={1}
          cropRotate
          beforeUpload={beforeUpload}
          onPreview={onPreview}
          showGuidelines={false}
        />
      </div>

      {/*  */}
      <div className="border p-4 rounded-2xl">
        <div className="mb-4 text-19px text-gray-600 font-bold ">
          {t("Ordering widget")}
        </div>
        <div className="py-2 w-full">
          <AppInput
            label={t("Title")}
            maxLength={10}
            placeholder={t("Enter title")}
            value={orderNowPopupConfig?.title}
            onInput={(event) => {
              const inputValue = event.target.value;
              if (inputValue?.length <= 10) {
                handleConfig("title", inputValue);
              } else {
                handleConfig("title", inputValue.substring(0, 10));
              }
            }}
          />
        </div>
        <div className="py-2 w-full">
          <AppInput
            label={t("Message")}
            maxLength={38}
            placeholder={t("Enter message")}
            value={orderNowPopupConfig?.message}
            onInput={(event) => {
              const inputValue = event.target.value;
              if (inputValue?.length <= 38) {
                handleConfig("message", inputValue);
              } else {
                handleConfig("message", inputValue.substring(0, 38));
              }
            }}
          />
        </div>
        <div className="py-2 w-full">
          <AppInput
            label={t("Button text")}
            maxLength={10}
            placeholder={t("Enter button text")}
            value={orderNowPopupConfig?.buttonText}
            onInput={(event) => {
              const inputValue = event.target.value;
              if (inputValue?.length <= 10) {
                handleConfig("buttonText", inputValue);
              } else {
                handleConfig("buttonText", inputValue.substring(0, 10));
              }
            }}
          />
        </div>
      </div>
      
        {/* <div className="flex justify-between">
          <label className="text-gray-600 font-bold text-14px">
            {t("Title")}
          </label>
          <label className="text-14px text-gray-400">
            {t("Max 10 Charaters Allowed")}
          </label>
        </div>

        <Input
          maxLength={10}
          minLength={2}
          compact
          placeholder={t("Enter title")}
          value={orderNowPopupConfig?.title}
          className="py-2 rounded"
          onChange={(event) => {
            const inputValue = event.target.value;
            if (inputValue?.length <= 10) {
              handleConfig("title", inputValue);
            } else {
              handleConfig("title", inputValue.substring(0, 10));
            }
          }}
        /> */}
      
      
        {/* <div className="flex justify-between">
          <label className="text-gray-600 font-bold text-14px">
            {t("Message")}
          </label>
          <label className="text-14px text-gray-400">
            {t("Max 38 Charaters Allowed")}
          </label>
        </div>

        <Input
          maxLength={38}
          compact
          placeholder={t("Enter message")}
          value={orderNowPopupConfig?.message}
          className="py-2 rounded"
          onChange={(event) => {
            const inputValue = event.target.value;
            if (inputValue?.length <= 38) {
              handleConfig("message", inputValue);
            } else {
              handleConfig("message", inputValue.substring(0, 38));
            }
          }}
        /> */}
      

      
        {/* <div className="flex justify-between">
          <label className="text-gray-600 font-bold text-14px">
            {t("Button text")}
          </label>
          <label className="text-14px text-gray-400">
            {t("Max 10 Charaters Allowed")}
          </label>
        </div>

        <Input
          maxLength={10}
          compact
          placeholder={t("Enter button text")}
          value={orderNowPopupConfig?.buttonText}
          className="py-2 rounded"
          onChange={(event) => {
            const inputValue = event.target.value;
            if (inputValue?.length <= 10) {
              handleConfig("buttonText", inputValue);
            } else {
              handleConfig("buttonText", inputValue.substring(0, 10));
            }
          }}
        /> */}
      {/* <div className="flex gap-3">
            <div className="w-2/3">
                <div>
                    <AppImageVideoUpload label="Cover Image/Video" width={300} height={120}/>
                </div>
                <div className="mt-10">
                    <AppImageVideoUpload label="Brand Logo" width={300} height={120}/>
                </div>
                <div className="flex items-center gap-3 mt-10">
                    <AppColorPicker label="Text color" className="w-1/2"/>
                    <AppColorPicker label="Base color" className="w-1/2"/>
                </div>

                <AppInput label="Tag line" placeholder="You Crave. We Deliver..."/>

                <div className="p-4 rounded-2xl border border-gray-200 bg-white mt-10">
                    <div className="flex justify-between items-center">
                        <AppHeading2>Ordering widget</AppHeading2>
                        <AppOutlineButton className="ml-auto">Apply Changes</AppOutlineButton>
                    </div>
                    <AppInput label="Title " placeholder="Enter Title"/>
                    <AppInput label="Message" placeholder="Enter Message"/>
                    <AppInput label="Button Text" placeholder="Enter Button Text"/>
                </div>
                
            </div>
            <div className="w-1/3">
                <div className="p-4 rounded-2xl border border-gray-200 bg-blue-100">
                    <div className="flex justify-between items-center">
                        <AppHeading2>Ordering menu preview</AppHeading2>
                        <AppOutlineButton size="sm" className="ml-auto">Refreash</AppOutlineButton>
                    </div>
                </div>
            </div>
         </div> */}

      
    </div>
  );
};

export default BrandingPlatformCustomizeAndWidget;
